var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30.354,
    viewBox: "0 0 32 30.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#606060}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(91.548 -389.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    d: "M-78.275 409.867a5.581 5.581 0 0 0-3.76 1.386 33.325 33.325 0 0 1-4.146 2.341 1.663 1.663 0 0 1-.806.219c-.345-.013-.824-.046-.987-.264a1.283 1.283 0 0 1 .054-1.008c.452-1.15.975-2.273 1.443-3.417.184-.448.025-.736-.431-1.014a9.693 9.693 0 0 1-4.049-11.459 9.973 9.973 0 0 1 5.095-5.222 15.771 15.771 0 0 1 9.046-1.746 15.931 15.931 0 0 1 7.351 2.6c6.29 4.382 5.011 12.476-.971 15.775a15.383 15.383 0 0 1-7.839 1.809zm-6.7 1.135c1.144-.964 2.183-1.8 3.17-2.69a1.858 1.858 0 0 1 1.586-.5 14.431 14.431 0 0 0 7.723-1.013 8.285 8.285 0 0 0 4.818-5.12c.945-3.071-.182-5.919-3.081-7.825a13.985 13.985 0 0 0-10.129-1.951A11.93 11.93 0 0 0-87 394.575a6.436 6.436 0 0 0-2.469 4.432 7.783 7.783 0 0 0 4.435 7.81c.494.25.719.52.61 1.078-.185.958-.34 1.923-.547 3.105z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    d: "M-56.575 437.608a2.2 2.2 0 0 1-2.221 2.167 2.218 2.218 0 0 1-2.26-2.214 2.212 2.212 0 0 1 2.239-2.156 2.161 2.161 0 0 1 2.242 2.203z",
    className: "cls-1",
    transform: "translate(-24.988 -37.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    d: "M6.333 435.448a2.154 2.154 0 0 1 2.151 2.217 2.2 2.2 0 0 1-2.173 2.141 2.167 2.167 0 0 1-2.142-2.234 2.134 2.134 0 0 1 2.164-2.124z",
    className: "cls-1",
    transform: "translate(-78.443 -37.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    d: "M-23.566 437.6a2.17 2.17 0 0 1-2.188 2.189 2.162 2.162 0 0 1-2.123-2.176 2.136 2.136 0 0 1 2.18-2.182 2.168 2.168 0 0 1 2.131 2.169z",
    className: "cls-1",
    transform: "translate(-52.181 -37.575)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    transform: "translate(-89.224 418.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    d: "M-78.364 551.163a.788.788 0 0 0-.306-.1z",
    className: "cls-1",
    transform: "translate(78.67 -551.066)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    d: "M-8.661 468.174C.723 461.5-7.578 455-7.578 455-9.744 466.91-24 465.286-24 465.286a10.486 10.486 0 0 0 10.286 4.331s5.642 5.143 6 3.664c.317-1.318-.946-5.107-.946-5.107",
    className: "cls-1",
    transform: "translate(-55.358 -53.615)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.7344acf13a0830ad256850cbb0ce2231.svg";
export { ForwardRef as ReactComponent };